// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__FfEIU","logo":"style_logo__Nu95A"};